import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-layout-page',
  standalone: true,
  imports: [],
  templateUrl: './main-layout-page.component.html',
  styleUrls: ['./main-layout-page.component.scss']
})
export class MainLayoutPageComponent implements OnInit {
  @Input() isSideNavCollapsed: boolean;
  
  constructor() { }

  ngOnInit(): void {
  }

}
